import React, { FC } from "react";
import { Input, Label, Radio } from "@trussle/external-components";
import { trackEvent } from "../../../../../helpers/analytics";

interface ISmartBuyerFormProps {
    buyingType: string;
    setBuyingType: (buyingType: string) => void;
    propertyType: string;
    setPropertyType: (propertyType: string) => void;
    propertyValue: string;
    setPropertyValue: (propertyValue: string) => void;
}

const SmartBuyerForm: FC<ISmartBuyerFormProps> = ({
  buyingType, setBuyingType, propertyType, setPropertyType, propertyValue, setPropertyValue,
}) => (
  <form>
    <div className="form-group">
      <Label title="Are you" htmlFor="smart-buyer-calculator-buyingType" className="calculator-label" />
      <Radio
        id="smart-buyer-calculator-buyingType"
        data-testid="smart-buyer-calculator-buyingType"
        className="calculator-input"
        options={[
          { code: "0", description: "Buying only" },
          { code: "1", description: "Buying and Selling" },
        ]}
        value={buyingType}
        onChange={(e) => {
          trackEvent("Buying Type Changed", {
            module: "Smart Buyer Calculator",
            value: e.target.value,
            element_type: "Radio",
          });
          setBuyingType(e.target.value);
        }}
      />
    </div>
    <div className="form-group">
      <Label title="Property Type" htmlFor="smart-buyer-calculator-propertyType" className="calculator-label" />
      <Radio
        id="smart-buyer-calculator-propertyType"
        data-testid="smart-buyer-calculator-propertyType"
        className="calculator-input"
        options={[
          { code: "0", description: "Leasehold" },
          { code: "1", description: "Freehold" },
        ]}
        value={propertyType}
        inline
        onChange={(e) => {
          trackEvent("Property Type Changed", {
            module: "Smart Buyer Calculator",
            value: e.target.value,
            element_type: "Radio",
          });
          setPropertyType(e.target.value);
        }}
      />
    </div>
    <div className="form-group">
      <Label title="" htmlFor="smart-buyer-calculator-propertyValue" className="calculator-label" />
      <Input
        variant="currency"
        name="Property value"
        label="What is property value?"
        inputSize="large"
        id="smart-buyer-calculator-propertyValue"
        data-testid="smart-buyer-calculator-propertyValue"
        className="calculator-input"
        value={propertyValue}
        required
        onChange={(e) => {
          trackEvent("Property Value Changed", {
            module: "Smart Buyer Calculator",
            value: e.target.value,
            element_type: "Text field",
          });
          setPropertyValue(e.target.value);
        }}
      />
    </div>
  </form>
);

export default SmartBuyerForm;
